export default __webpack_public_path__ + "static/media/hsbc-logo-v3.6e0d0f34.svg";